import { field, children, lazy, writer,text } from "@nozbe/watermelondb/decorators";
import { USER_SCHEMA, BUSINESS_SCHEMA } from "../schema";
import { uuid } from "../../oscar-pos-core/constants";
import { Model, Q } from "@nozbe/watermelondb";

export default class User extends Model {
  static table = USER_SCHEMA;

  static associations = {
    analytics_events: { type: 'has_many', foreignKey: 'user_id' },
    guided_tours: { type: 'has_many', foreignKey: 'user_id' },
    notification: { type: 'has_many', foreignKey: 'user_id' },
    signatures: { type: 'has_many', foreignKey: 'user_id' },
    last_sync: { type: "has_many", foreignKey: "user_id" },
    business: { type: "has_many", foreignKey: "user_id" },
    contacts: { type: "has_many", foreignKey: "user_id" },
    wishlist: { type: 'has_many', foreignKey: 'user_id' },
    address: { type: "has_many", foreignKey: "user_id" },
    nudge: { type: 'has_many', foreignKey: 'user_id' },
  };

  @text('alternate_number') alternate_number;
  @text("bank_account_no") bank_account_no;
  @text("activation_code") activation_code;
  @text("telco_network") telco_network;
  @text("phone_number") phone_number;
  @text("device_token") device_token;
  @text("account_type") account_type;
  @field("has_wallet") has_wallet;
  @field("is_synced") is_synced;
  @field("is_active") is_active;
  @text("referral") referral;
  @text("currency") currency;
  @text("country") country;
  @text("name") name;
  @text("bank") bank;
  @text("type") type;

  @children('analytics_events') analytics_events;
  @children('notification') notification;
  @children('guided_tours') guided_tours;
  @children('signatures') signatures;
  @children("last_sync") last_sync;
  @children("business") business;
  @children("contacts") contacts;
  @children('wishlist') wishlist;
  @children("address") address;
  @children('nudge') nudge;

  @lazy activeBusiness = this.business.extend(Q.where("is_active", true));

  @writer async activateUser(code) {
    return await this.update((user) => {
      user.activation_code = code;
      user.is_active = true;
    });
  }
  @writer async updatePhone(phone_number) {
    return await this.update((user) => {
      user.phone_number = phone_number;
      user.is_active = true;
    });
  }

  @writer async deactivateUser() {
    await this.update((user) => {
      user.is_active = false;
    });
  }

  @writer async activateUserOnly() {
    return await this.update((user) => {
      user.is_active = true;
    });
  }

  @writer async createBusiness(name, id = false, report_url = false, category) {
    return await this.collections.get(BUSINESS_SCHEMA).create((business) => {
      business.last_active_at = new Date().getTime();
      business._raw.id = id ? id : uuid();
      business.report_url = report_url;
      business.is_active = true;
      business.user.set(this);
      business.name = name;
      business.category = category;
    });
  }

  @writer async deleteDatabase(database) {
    await database.unsafeResetDatabase();
  }

  @writer async markAsDeleted() {
    await super.markAsDeleted();
  }
};
